import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { imgSrc, uploadImage, errMsg } from "@/lib/api";
import { t } from "@/lib/i18n";
import { toast } from "sonner";

export const MAX_STORY_PHOTOS = 4;

export const StoryPhotoPicker = ({ photos, onChange }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = [...(e.target.files || [])].slice(0, MAX_STORY_PHOTOS - photos.length);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    const added = [];
    for (const file of files) {
      try { added.push(await uploadImage(file)); } catch (err) { toast.error(errMsg(err)); }
    }
    onChange([...photos, ...added]);
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="story-photo-picker">
      {photos.map((ph) => (
        <div key={ph.path} className="relative">
          <img src={imgSrc(ph.url)} alt="" className="w-20 h-20 object-cover rounded-xl border border-[#E5DEC9]" />
          <button type="button" onClick={() => onChange(photos.filter((x) => x.path !== ph.path))} aria-label="Remove photo"
            className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#1C2421] text-white grid place-items-center" data-testid="story-photo-remove"><X className="w-3.5 h-3.5" /></button>
        </div>
      ))}
      {photos.length < MAX_STORY_PHOTOS && (
        <>
          <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={pick} data-testid="story-photo-input" />
          <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid="story-photo-btn"
            className="w-20 h-20 rounded-xl border-2 border-dashed border-[#CDBF9F] bg-white grid place-items-center text-[#7E8E85] hover:border-[#1E3A2B] transition-colors">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <span className="flex flex-col items-center text-[10px] gap-1"><ImagePlus className="w-5 h-5" />{t("Add photos")}</span>}
          </button>
        </>
      )}
    </div>
  );
};

export const StoryPhotos = ({ photos, onOpen, storyId }) => {
  if (!photos?.length) return null;
  return (
    <div className={`grid gap-2 ${photos.length === 1 ? "grid-cols-1 max-w-md" : "grid-cols-2 sm:grid-cols-4"}`} data-testid={`story-photos-${storyId}`}>
      {photos.map((url, i) => (
        <button key={url} onClick={() => onOpen(url)} className="block group" data-testid={`story-photo-${storyId}-${i}`}>
          <img src={imgSrc(url)} alt="" loading="lazy" className={`w-full object-cover rounded-2xl border border-[#E5DEC9] transition-transform duration-300 group-hover:-translate-y-0.5 ${photos.length === 1 ? "max-h-80" : "aspect-square"}`} />
        </button>
      ))}
    </div>
  );
};
